import React from 'react';
import { Item } from './styles';

export default function MotorSettings({ timestamp, data }) {
  if (!data) return null;

  return (
    <Item>
      <h3 style={{ marginBlockEnd: 0 }}>Motor settings</h3>
      <div>
        <p style={{ marginLeft: '1em' }}>
          {`Gain: ${data.motor_gain}`}<br />
          {`Offset: ${data.motor_offset}`}<br />
          {`Torque filter: ${JSON.stringify(data.motor_torque_filter, null, 1)}`}<br />
          {`Max torque: ${data.motor_max_torque}`}<br />
          {`Max rpm: ${data.motor_max_rpm}`}<br />
        </p>
      </div>
    </Item>
  );
}
